import CalendarProcessingOptions from 'owa-service/lib/contract/CalendarProcessingOptions';
import getStore from '../data/store/store';

/**
 * Util to get calendar processing options from store
 */

export default function getCalendarOptions(): CalendarProcessingOptions {
    return getStore().calendarProcessingOptions;
}
